var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"PayView"}},[_c('van-overlay',{staticStyle:{"text-align":"center"},attrs:{"show":_vm.loading}},[_c('van-loading',{attrs:{"type":"spinner"}},[_vm._v("加载中...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }